<ng-container *ngIf="items.length > 0">
  <ul class="list-group-notification">
      <li *ngFor="let item of items; let i = index" class="list-group-notification-item">
        {{ i+1 }}) {{ item.name }} ; {{ item.title }}
      </li>
  </ul>
</ng-container>

